import styled from '@emotion/styled';
import IconButton from '../IconButton/IconButton';

// Alert Actions
export const AlertActionsRoot = styled('div')`
  position: relative;
`;
export const AlertCloseAction = styled(IconButton)`
  position: absolute;
  right: -8px;
  top: -2px;
`;

export default {};
